import registerLoops from "./register-loops.js";
import renderLoop from "./render-loop.js";

const loop = {
	registerLoops,
	renderLoop,
};

export default loop;
